import React from 'react'
import PropTypes from 'prop-types'
import css from './styles.css'

const Header = ({
  showCancelButton,
  openCancellationDialog,
  closeSelectedBlastModal,
  messageType
}) =>  (
  <div className={css.header}>
    {showCancelButton ?
    <button
      className={css.cancelMessage}
      onClick={openCancellationDialog}
    >
      DELETE
    </button> :
    <div className={css.cancelMessage} style={{ visibility: 'hidden' }} />}
    <h3>{messageType}</h3>
    <span
      className={css.closeModal}
      onClick={closeSelectedBlastModal}
    >
      x
    </span>
  </div>
)

Header.propTypes = {
  showCancelButton: PropTypes.bool.isRequired,
  openCancellationDialog: PropTypes.func.isRequired,
  closeSelectedBlastModal: PropTypes.func.isRequired,
  messageType: PropTypes.string.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/SelectedBlast/Header.js